import axios from '../../axios'
import Axios, { AxiosRequestConfig } from 'axios'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { toast } from 'react-toastify'
import { Permission } from './types'

export class PermissionsStore {
  loadingList: boolean = false
  deleting: boolean = false
  list: Permission[] = []
  entries: {
    [key: string]: Permission
  } = {}
  totalPages: number = 0
  totalElements: number = 0
  cancelTokenSource = () => {}

  constructor() {
    makeObservable(this, {
      loadingList: observable,
      deleting: observable,
      list: observable,
      entries: observable,
      totalPages: observable,
      totalElements: observable,
      getData: action,
      delete: action,
      setPermission: action,
      reset: action,
      clearList: action,
      removeFromList: action,
      setLoadingList: action,
    })
  }

  reset = () => {
    this.clearList()
    this.deleting = false
    this.entries = {}
    this.cancelTokenSource = () => {}
  }

  clearList = () => {
    this.loadingList = false
    this.list = []
    this.totalPages = 0
    this.totalElements = 0
  }

  setLoadingList = (value: boolean) => {
    this.loadingList = value
  }

  removeFromList = (id: number) => {
    this.list = this.list.filter((item) => item.id !== id)
  }

  create = async (data: object) => {
    return await axios
      .post('/management/api/v1/permission', data)
      .then((response) => {
        toast.success('Created successfully')
        return response
      })
  }

  update = async (id: number, data: object) => {
    return await axios
      .put('/management/api/v1/permission/' + id, data)
      .then((response) => {
        toast.success('Updated successfully')
        return response
      })
  }

  delete = async (id: number) => {
    this.deleting = true
    await axios
      .delete('/management/api/v1/permission/' + id)
      .then(({ data }) => {
        toast.success('Deleted successfully')
        this.removeFromList(id)
      })
      .finally(() => {
        this.deleting = false
      })
  }

  getById = async (id: number) => {
    return await axios(`/management/api/v1/permission/${id}`).then(
      ({ data }) => {
        this.setPermission(data)
        return data
      }
    )
  }

  getData = (filters: any = {}) => {
    if (typeof this.cancelTokenSource == 'function') {
      // this.cancelTokenSource()
    }
    const cancelTokenSource = Axios.CancelToken.source()

    const params: any = {
      ...filters,
      name: filters.searchValue,
    }
    delete params.searchValue

    this.setLoadingList(true)

    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
      params,
    }
    axios
      .get(`/management/api/v1/permission`, config)
      .then(({ data }) => {
        if (data?.content) {
          runInAction(() => {
            this.list = data.content
            this.totalPages = data.totalPages
            this.totalElements = data.totalElements
            this.list.forEach((item) => (this.entries[`${item.id}`] = item))
          })
        }
      })
      .catch(() => {
        this.clearList()
      })
      .finally(() => {
        this.setLoadingList(false)
      })

    this.cancelTokenSource = cancelTokenSource.cancel
  }

  setPermission = (folder: Permission) => {
    const index = this.list.findIndex((item: Permission) => item.id === folder.id)
    if (index !== -1) {
      this.list[index] = folder
    }
    this.entries[`${folder.id}`] = folder
  }

  searchPermissions = async (searchValue: string, cancelTokenSource?: any) => {
    const { data } = await axios.get(
      `/management/api/v1/permission?name=${encodeURIComponent(
        searchValue
      )}&size=${5}`,
      {
        // @ts-ignore
        cancelTokenSource,
      }
    )
    return data.content as Permission[]
  }

  getAllPermissions = async () => {
    const { data } = await axios.get(`/management/api/v1/permission`)
    return data as {[key: string]: Permission[]}
  }
}

export const permissionsStore = new PermissionsStore()
